<template>
    <div class="container">
        <van-nav-bar
            title="Register"
            left-text="Back"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="main">
            <div id="firebaseui-auth-container"></div>
            <div id="loader">Loading...</div>
        </div>
    </div>
</template>
<script>
import firebase from '../utils/firebase'
import {bindStore,getDownloadurl} from "../api/index"
import { Toast } from "vant";
export default {
    data() {
        return {
            storeId:0,
        }
    },
    destroyed(){
    },
    mounted() {
        this.storeId = localStorage.getItem('storeId')
        this.initFirebase()
    },
    methods:{
        initFirebase() {
            var that = this;
            let uiConfig = {
                    callbacks: {
                        signInSuccessWithAuthResult: function(authResult, redirectUrl) {
                        // User successfully signed in.
                        // Return type determines whether we continue the redirect automatically
                        // or whether we leave that to developer to handle.
                            that.login(authResult, redirectUrl)
                            return false;
                        },
                        uiShown: function() {
                        // The widget is rendered.
                        // Hide the loader.
                            document.getElementById('loader').style.display = 'none';
                        }
                    },
                    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
                    signInFlow: 'popup',
                    // signInSuccessUrl: '/',
                    signInOptions: [
                        // Leave the lines as is for the providers you want to offer your users.
                        // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                        // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                        // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                        // firebase.auth.GithubAuthProvider.PROVIDER_ID,
                        {
                            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID
                        },
                        {
                            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
                            defaultCountry:"GB"
                        }
                        
                    ],
                    // Terms of service url.
                    // tosUrl: '<your-tos-url>',
                    // Privacy policy url.
                    // privacyPolicyUrl: '<your-privacy-policy-url>'
                };
            firebase.$ui.start('#firebaseui-auth-container', uiConfig);
                    
        },
        login(authResult, redirectUrl){
            let parmas = {
                "storeId": this.storeId,
                "token": authResult.user.multiFactor.user.accessToken
            }
            bindStore(parmas).then(res => {
                this.getDownloadurl()
                // window.location.href="http://www.域名/template.xlsx(文件名)" //下载
            })
        },
        onClickLeft() {
            this.$router.push({path:'/',query:{storeId:this.storeId}})
        },
        getDownloadurl() {
            let type = 1;
            var u = navigator.userAgent;
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            if(isiOS == true) {
                type = 2;
            }else if(isAndroid == true){
                type = 1;
            }
            getDownloadurl({sysType:type}).then(res => {
                if(type == 1){
                    window.location.href =  res.data;
                    this.$router.push({path:'/',query:{storeId:this.storeId}})
                }else {
                   Toast('敬請期待') 
                }
            })  
        }
    }
}
</script>
<style scoped>
.container {
    position:relative;
    width: 10.8rem;
    height: 100vh;
    background: url('../assets/images/login_bg.png') no-repeat;
    background-size: 100% 100%;
}
.main {
    position:absolute;
    margin:auto;
    top:25%;
    left:0;
    right:0;
    bottom:0;
}
.van-nav-bar {
    background: transparent;
}
.van-hairline--bottom::after {
    border: none;
}
</style>